<dx-popup [title]="title"
          [visible]="isVisible"
          [shading]="true"
          [resizeEnabled]="false"
          [closeOnOutsideClick]="false"
          [height]="'auto'"
          (onHiding)="popupHiding()">
  <dx-scroll-view width="100%" height="100%" [useNative]="true">
    <dx-data-grid #referenceDataGrid
                  [dataSource]="data"
                  [allowColumnReordering]="false"
                  [allowColumnResizing]="true"
                  [columnAutoWidth]="true"
                  [showBorders]="true"
                  [keyExpr]="'K3VRowKey'"
                  [(selectedRowKeys)]="selectedRows"
                  [width]="getGridWidth()"
                  [hoverStateEnabled]="true"
                  [loadPanel]="loadPanelConfiguration">
      <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode" [mode]="selectionMode"></dxo-selection>
      <ng-container *ngFor="let headerColumn of headerColumns">
        <dxi-column [caption]="headerColumn.DisplayName" [dataField]="headerColumn.FieldName" [dataType]="headerColumn.dataType" [format]="headerColumn.format"></dxi-column>
      </ng-container>
      <dxo-scrolling [columnRenderingMode]="'virtual'" [useNative]="true"></dxo-scrolling>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-paging [pageSize]="5"></dxo-paging>
      <dxo-pager [visible]="true"
                 [allowedPageSizes]="allowedPageSizes"
                 [displayMode]="pagerDisplayMode"
                 [showPageSizeSelector]="true"
                 [showInfo]="true"
                 [showNavigationButtons]="true">
      </dxo-pager>
    </dx-data-grid>
    <div class="button-container">
      <dx-button id="btnSave" text="{{'Select' | translate}}" type="success" (click)="createReference($event)"></dx-button>
        <dx-button id="btnCancel" text="{{'Cancel' | translate}}" type="default"
                   (click)="cancelReference()"></dx-button>
    </div>
  </dx-scroll-view>
</dx-popup>
